/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import { useEffect, useState } from 'react';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import Module from './Module';
import DataPanel from '../../../../Components/DataPanel/DataPanel';
import LoadingBar from '../../../../Components/LoadingBar/LoadingBar';
import XpektorButton from '../../../../Components/XpektorButton/XpektorButton';
import { TranslateTriggers } from '../../../../Components/Utilities/TriggerTexts/DefaultTriggers';
import GraphPreviewImage from '../../../../Images/graphPreviewImage.png';

const gT = (t, key) => t(`company-info-modules.management${key}`);

export default function Management({
  managementStatus,
  onPdfClick,
  onHistoryClick,
  onTriggerClick,
  t,
}) {
  const [translatedTriggers, setTranslatedTriggers] = useState([]);

  useEffect(() => {
    if (managementStatus !== null && Object.keys(managementStatus).length > 0) {
      setTranslatedTriggers(TranslateTriggers(managementStatus.triggers));
    }
  }, [managementStatus]);

  return (
    <Module>
      {!managementStatus ? (
        <p className="module-empty-text">{gT(t, '.module-empty-text')}</p>
      ) : !managementStatus?.managementReport ? (
        <LoadingBar active status={gT(t, '.loading-bar')} relative />
      ) : (
        <>
          <Module.Nav>
            <div />
            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
              <XpektorButton
                icon={faDownload}
                content={gT(t, '.xpektor-btn.save-as-pdf')}
                onClick={() =>
                  onPdfClick(() =>
                    document.getElementById('management-pdf-wrapper')
                  )
                }
              />
            </div>
          </Module.Nav>
          <div id="management-pdf-wrapper">
            <Module.KeyFigureSection>
              <Module.KeyFigure
                title={gT(t, '.key-figure.title.solidity-percentage')}
                value={managementStatus.managementReport.solidityPercentage}
                valueType="percentage"
              />
              <Module.KeyFigure
                title={gT(t, '.key-figure.title.debt-percentage')}
                value={managementStatus.managementReport.debtPercentage}
                valueType="percentage"
              />
              <Module.KeyFigure
                title={gT(t, '.key-figure.title.gross-profit-margin')}
                value={managementStatus.managementReport.grossProfitMargin}
                valueType="percentage"
              />
              <Module.KeyFigure
                title={gT(t, '.key-figure.title.operating-margin')}
                value={managementStatus.managementReport.operatingMargin}
                valueType="percentage"
              />
              <Module.KeyFigure
                title={gT(t, '.key-figure.title.liquidity')}
                value={managementStatus.managementReport.liquidity}
                valueType="percentage"
              />
            </Module.KeyFigureSection>
            <Module.DataSection>
              <Module.DataColumn>
                <DataPanel title={gT(t, '.data-panel.title.history')}>
                  <img src={GraphPreviewImage} alt="graph-preview" />
                  <DataPanel.Button
                    text={gT(t, '.data-panel.btn.history')}
                    onClick={onHistoryClick}
                  />
                </DataPanel>
                <DataPanel
                  title={gT(t, '.data-panel.title.to-keep-in-mind')}
                  icon={faBell}
                  scroll
                  maxHeight={400}
                >
                  {translatedTriggers.map((data) => {
                    return (
                      <DataPanel.TriggerEntry
                        text={data.texts.name}
                        onClick={() => onTriggerClick(data.texts)}
                        key={`${data.id} management`}
                      />
                    );
                  })}
                </DataPanel>
              </Module.DataColumn>
              <Module.DataColumn>
                <DataPanel
                  title={gT(t, '.data-panel.title.result-indications')}
                >
                  <DataPanel.ValueEntry
                    label={gT(
                      t,
                      '.value-entry.label.revenue-variation-percentage'
                    )}
                    value={
                      managementStatus.managementReport
                        .revenueVariationPercentage
                    }
                    valueType="percentage"
                    info={gT(
                      t,
                      '.value-entry.info.revenue-variation-percentage'
                    )}
                  />
                  <DataPanel.ValueEntry
                    label={gT(t, '.value-entry.label.average-revenue')}
                    value={
                      managementStatus.managementReport.averageRevenue * -1
                    }
                    valueType="currency"
                    info={gT(t, '.value-entry.info.average-revenue')}
                  />
                </DataPanel>
                <DataPanel
                  title={gT(
                    t,
                    '.data-panel.title.significant-cost-increases-decreases'
                  )}
                >
                  {managementStatus.triggers.includes(24) ? (
                    <DataPanel.ValueEntry
                      label={gT(
                        t,
                        '.value-entry.label.external-cost-increased'
                      )}
                    />
                  ) : managementStatus.triggers.includes(25) ? (
                    <DataPanel.ValueEntry
                      label={gT(
                        t,
                        '.value-entry.label.external-cost-decreased'
                      )}
                    />
                  ) : (
                    ''
                  )}
                  {managementStatus.triggers.includes(34) ? (
                    <DataPanel.ValueEntry
                      label={gT(t, '.value-entry.label.item-cost-increased')}
                    />
                  ) : managementStatus.triggers.includes(35) ? (
                    <DataPanel.ValueEntry
                      label={gT(t, '.value-entry.label.item-cost-decreased')}
                    />
                  ) : (
                    ''
                  )}
                  {managementStatus.triggers.includes(36) ? (
                    <DataPanel.ValueEntry
                      label={gT(t, '.value-entry.label.salary-cost-increased')}
                    />
                  ) : managementStatus.triggers.includes(37) ? (
                    <DataPanel.ValueEntry
                      label={gT(t, '.value-entry.label.salary-cost-decreased')}
                    />
                  ) : (
                    ''
                  )}
                  {managementStatus.triggers.includes(38) ? (
                    <DataPanel.ValueEntry
                      label={gT(
                        t,
                        '.value-entry.label.impairment-depreciation-cost-increased'
                      )}
                    />
                  ) : managementStatus.triggers.includes(39) ? (
                    <DataPanel.ValueEntry
                      label={gT(
                        t,
                        '.value-entry.label.impairment-depreciation-cost-decreased'
                      )}
                    />
                  ) : (
                    ''
                  )}
                  {managementStatus.triggers.includes(40) ? (
                    <DataPanel.ValueEntry
                      label={gT(t, '.value-entry.label.other-cost-increased')}
                    />
                  ) : managementStatus.triggers.includes(41) ? (
                    <DataPanel.ValueEntry
                      label={gT(t, '.value-entry.label.other-cost-decreased')}
                    />
                  ) : (
                    ''
                  )}
                </DataPanel>
                <DataPanel
                  title={gT(t, '.data-panel.title.assets-indications')}
                >
                  {managementStatus.triggers.includes(28) ? (
                    <DataPanel.ValueEntry
                      label={gT(
                        t,
                        '.value-entry.label.assets-increased-3-months'
                      )}
                    />
                  ) : managementStatus.triggers.includes(29) ? (
                    <DataPanel.ValueEntry
                      label={gT(
                        t,
                        '.value-entry.label.assets-unchanged-3-months'
                      )}
                    />
                  ) : (
                    ''
                  )}
                  {managementStatus.triggers.includes(30) ? (
                    <DataPanel.ValueEntry
                      label={gT(
                        t,
                        '.value-entry.label."assets-increases-check-impairment-loss"'
                      )}
                    />
                  ) : (
                    ''
                  )}
                </DataPanel>
              </Module.DataColumn>
              <Module.DataColumn>
                <DataPanel
                  title={gT(t, '.data-panel.title.other-measures-needed')}
                >
                  {managementStatus.triggers.includes(26) ? (
                    <DataPanel.ValueEntry
                      label={gT(
                        t,
                        '.value-entry.label.company-missing-insurance'
                      )}
                    />
                  ) : (
                    ''
                  )}
                  {managementStatus.triggers.includes(27) ? (
                    <DataPanel.ValueEntry
                      label={gT(
                        t,
                        '.value-entry.label.company-accounts-legal-fees'
                      )}
                    />
                  ) : (
                    ''
                  )}
                  {managementStatus.triggers.includes(45) ? (
                    <DataPanel.ValueEntry
                      label={gT(
                        t,
                        '.value-entry.label.company-accounts-illegal-loans'
                      )}
                    />
                  ) : (
                    ''
                  )}
                </DataPanel>
                <DataPanel
                  title={gT(t, '.data-panel.title.equity-debt-indicators')}
                >
                  {managementStatus.triggers.includes(31) ? (
                    <DataPanel.ValueEntry
                      label={gT(t, '.value-entry.label.equity-varies')}
                    />
                  ) : (
                    ''
                  )}
                  {managementStatus.triggers.includes(32) ? (
                    <DataPanel.ValueEntry
                      label={gT(
                        t,
                        '.value-entry.label.long-term-debt-increased'
                      )}
                    />
                  ) : (
                    ''
                  )}
                </DataPanel>
              </Module.DataColumn>
            </Module.DataSection>
          </div>
        </>
      )}
    </Module>
  );
}
